import { convertModelToFormData } from '../../common/helpers/form-helpers';
import { monteurApi } from '../common/monteur-api';
export var companyApi = monteurApi
    .enhanceEndpoints({
    addTagTypes: ['Company', 'PaginatedCompanies', 'Companies', 'UserCompanies']
})
    .injectEndpoints({
    endpoints: function (builder) { return ({
        createCompany: builder.mutation({
            query: function (company) { return ({
                url: 'Company/create',
                method: 'POST',
                body: convertModelToFormData(company)
            }); },
            invalidatesTags: ['Companies', 'PaginatedCompanies', 'Company']
        }),
        updateCompany: builder.mutation({
            query: function (company) { return ({
                url: 'Company/update',
                method: 'POST',
                body: convertModelToFormData(company)
            }); },
            invalidatesTags: ['Companies', 'PaginatedCompanies', 'Company']
        }),
        getCompany: builder.query({
            query: function (id) { return ({
                url: "Company/get-by-id?id=".concat(id),
                method: 'GET'
            }); },
            providesTags: ['Company']
        }),
        getAllCompanies: builder.query({
            query: function (query) { return ({
                url: "Company/get-all?filterByCompany=".concat(query.filterByCompany),
                method: 'GET'
            }); },
            providesTags: ['Companies']
        }),
        getPaginatedCompanies: builder.query({
            query: function (query) { return ({
                url: 'Company/get-paginated',
                method: 'POST',
                body: query
            }); },
            providesTags: ['PaginatedCompanies']
        }),
        getCompaniesByUser: builder.query({
            query: function () { return ({
                url: "Company/get-all-by-user",
                method: 'GET'
            }); },
            providesTags: ['UserCompanies']
        }),
        updateCompanyStatus: builder.mutation({
            query: function (command) { return ({
                url: 'Company/update-status',
                method: 'POST',
                body: command
            }); },
            invalidatesTags: ['Companies', 'Company', 'PaginatedCompanies', 'Users']
        })
    }); }
});
export var useCreateCompanyMutation = companyApi.useCreateCompanyMutation, useGetPaginatedCompaniesQuery = companyApi.useGetPaginatedCompaniesQuery, useGetAllCompaniesQuery = companyApi.useGetAllCompaniesQuery, useLazyGetCompanyQuery = companyApi.useLazyGetCompanyQuery, useUpdateCompanyMutation = companyApi.useUpdateCompanyMutation, useGetCompaniesByUserQuery = companyApi.useGetCompaniesByUserQuery, useUpdateCompanyStatusMutation = companyApi.useUpdateCompanyStatusMutation;
